import { MenuBar } from '../../components/MenuBar'
import { Content } from '../../components/Content'
import { Footer } from '../../components/Footer'
import { HeaderBanner } from '../../components/HeaderBanner'
import MetaTags from '../../components/MetaTags'
import { Cookies } from '../../components/Cookies'
import { ContentCard } from '../../components/ContentCard'
import { Link, LinkVariant } from '../../components/Link'
import { BlogPostCard } from '../../components/BlogPostCard'
import { getBlogPostResponse, getHeaderQuery } from '../../lib/strapi/queries'
import { strapiDateToString, getStrapiMedia } from '../../lib/strapi/helpers'

import '../../i18n/i18n'
import { useTranslation } from 'react-i18next'

import blogHeaderImage from '../../public/assets/pages/blog/header_mountain_outline_mist_sunrise_mist_1x3.3.jpg'
import { BlogPostsType, BlogPostType, Header, HeaderQuery } from '../../lib/strapi/responseTypes'
import { IS_PRODUCTION } from '../../config'
import { GetStaticPaths, GetStaticProps } from 'next'
import { useRouter } from 'next/router';

type BlogsPageData = { blogPosts: BlogPostsType, headerData: Header }

export default function BlogPage({blogPosts, headerData}: BlogsPageData) {
  const { t: translate } = useTranslation()
  const posts = blogPosts.data

  //feature the most recent blog post
  const featurePost = [...posts].shift()

  const { asPath } = useRouter();

  return (
    <>
      <MetaTags pageTitle={`${translate('blog')} - Protect Our Winters UK`} />
      <Cookies />
      <MenuBar currentPage={asPath} menuItems={headerData.data.attributes.menuItems} />
      <HeaderBanner imgSrc={blogHeaderImage} headingTranslationKey="blog" />
      <Content>
        {featurePost && (
          <ContentCard
            imgSrc={getStrapiMedia(featurePost.attributes.coverImage.data.attributes.url)}
            imgAlt={featurePost.attributes.coverImage.data.attributes.alternativeText}
            title={featurePost.attributes.title}
            cardHref={`/blog/${featurePost.attributes.slug}`}
            content=""
          >
            <span className="-mt-4 block">
              {strapiDateToString(featurePost.attributes.datePublished)}
            </span>
            <span className="block lg:mb-0.5">{featurePost.attributes.excerpt}</span>
            <Link
              href={`/blog/${featurePost.attributes.slug}`}
              variant={LinkVariant.FORWARD}
              translationKey={'readBlogArticle'}
            />
          </ContentCard>
        )}
        <div className="gap-x-6 gap-y-12 grid mx-auto pt-7 sm:pb-6 md:grid-cols-2 lg:grid-cols-3 md:max-w-full md:mx-0">
          {posts
            .filter((post: BlogPostType) => post.id !== featurePost?.id)
            .map((post: BlogPostType) => {
              return <BlogPostCard {...post} key={`blogpost__${post.attributes.slug}`} />
            })}
        </div>
      </Content>
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps<BlogsPageData> = async() => {

  const blogPostsList = await getBlogPostResponse(!IS_PRODUCTION)
  const blogPosts = blogPostsList.blogPosts

  const headerData = await getHeaderQuery({
    showPreview: !IS_PRODUCTION,
  })
  
  return {
    props: {blogPosts, headerData: headerData.header},
    revalidate: 1,
  }
}
